module.exports = __webpack_public_path__ + "img/img18.a9af43c5.svg";